// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/always-grey.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why-thy-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: #151515;
    color: #FFF;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.why-thy-container .why-thy-content {
    display: flex;
    /* gap: 20px; */
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    width: 80%;
}

.why-thy-container .divider {
    width: 80%;
    border-bottom: 1px solid #575555;
    text-align: center;
    margin-top: 30px;
  }

.why-thy-container .why-thy-title {
    font-size: 40px;
    margin-top: 30px;
    font-weight: 500;
    width: 80%;
    text-align: left;
}

.why-thy-container .why-thy-description {
    font-size: 24px;
    font-weight: 200;
    line-height: 1.5;
    /* padding: 0px 40px 0px 40px; */
}

.why-thy-container .why-thy-banner-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.why-thy-container .why-thy-details {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 50px;
    align-items: flex-start;
    text-align: left;
    padding: 40px;
    width: 60%;
}

.why-thy-container .why-thy-details-box {
    font-size: 24px;
    font-weight: 200;
    border: 1px solid #d9d9d91f;
    padding: 20px;
    border-radius: 12px;
    background-color: #262626;
    line-height: 1.5;
}


@media only screen and (max-width: 1000px) {
    .why-thy-container .why-thy-content {
        font-weight: 200;
          font-size: 20px;
        padding: 20px;
    }
    .why-thy-container .why-thy-title {
        font-size: 40px;
    }
    
    .why-thy-container .why-thy-description {
        font-size: 18px;
        padding: 0px;
    }
    
.why-thy-container .why-thy-banner-container {
  width: 100%;
  height: 270px;
}

.why-thy-container .why-thy-details {
    padding: 0px;
    width: 80%;
}

.why-thy-container .why-thy-details-box {
    font-size: 18px;
}

}`, "",{"version":3,"sources":["webpack://./src/pages/why-thy/why-thy.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,yDAA4D;AAChE;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;EAClB;;AAEF;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI;QACI,gBAAgB;UACd,eAAe;QACjB,aAAa;IACjB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;AAEJ;EACE,WAAW;EACX,aAAa;AACf;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA","sourcesContent":[".why-thy-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n    background-color: #151515;\n    color: #FFF;\n    background-image: url(\"../../assets/images/always-grey.png\");\n}\n\n.why-thy-container .why-thy-content {\n    display: flex;\n    /* gap: 20px; */\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    text-align: left;\n    width: 80%;\n}\n\n.why-thy-container .divider {\n    width: 80%;\n    border-bottom: 1px solid #575555;\n    text-align: center;\n    margin-top: 30px;\n  }\n\n.why-thy-container .why-thy-title {\n    font-size: 40px;\n    margin-top: 30px;\n    font-weight: 500;\n    width: 80%;\n    text-align: left;\n}\n\n.why-thy-container .why-thy-description {\n    font-size: 24px;\n    font-weight: 200;\n    line-height: 1.5;\n    /* padding: 0px 40px 0px 40px; */\n}\n\n.why-thy-container .why-thy-banner-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.why-thy-container .why-thy-details {\n    display: flex;\n    gap: 20px;\n    flex-direction: column;\n    justify-content: flex-start;\n    margin-top: 50px;\n    align-items: flex-start;\n    text-align: left;\n    padding: 40px;\n    width: 60%;\n}\n\n.why-thy-container .why-thy-details-box {\n    font-size: 24px;\n    font-weight: 200;\n    border: 1px solid #d9d9d91f;\n    padding: 20px;\n    border-radius: 12px;\n    background-color: #262626;\n    line-height: 1.5;\n}\n\n\n@media only screen and (max-width: 1000px) {\n    .why-thy-container .why-thy-content {\n        font-weight: 200;\n          font-size: 20px;\n        padding: 20px;\n    }\n    .why-thy-container .why-thy-title {\n        font-size: 40px;\n    }\n    \n    .why-thy-container .why-thy-description {\n        font-size: 18px;\n        padding: 0px;\n    }\n    \n.why-thy-container .why-thy-banner-container {\n  width: 100%;\n  height: 270px;\n}\n\n.why-thy-container .why-thy-details {\n    padding: 0px;\n    width: 80%;\n}\n\n.why-thy-container .why-thy-details-box {\n    font-size: 18px;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
